import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MedpaceDatepickerComponent } from '@components/atoms/medpace-datepicker/medpace-datepicker.component';
import { MdsDropdownComponent } from '@medpacesoftwaredevelopment/designsystem';
import { RequestMerchantStateService } from '@services/state-management/request-merchant-state.service';
import { MerchantDetailsFormGroup } from './merchant-details-edit.formgroup';

@Component({
    selector: 'medpace-merchant-details-edit',
    imports: [MedpaceDatepickerComponent, MdsDropdownComponent, AsyncPipe],
    templateUrl: './merchant-details-edit.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MerchantDetailsEditComponent {
    formGrp = input.required<MerchantDetailsFormGroup>();

    private travelMerchantStateService = inject(RequestMerchantStateService);

    travelMerchantValues$ = this.travelMerchantStateService.getTravelRequestMerchants();
}
